import EditTimeIcon from 'assets/icons/revamp/EditTimeIcon';
import { Zzz } from 'assets/icons/revamp';
import BaseButton from 'components/ui/BaseButton';
import COLOR from 'constants/color';
import { SETTING_TAB_INDEX } from 'constants/general';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { timingSelector } from 'store/reducer/setting/selectors';
import {
  setHighlightShutdownTime,
  updateActiveTabIndex
} from 'store/reducer/setting/slice';
import { formatTimeTo12Hour } from 'utils/time.util';

const EveningRoutineStartTimeRevamp: React.FC = () => {
  const dispatch = useAppDispatch();
  const { shutdown_time } = useAppSelectorShallow(timingSelector);
  const displayTime = shutdown_time
    ? formatTimeTo12Hour(shutdown_time)
    : t('finish_work_time');

  const handleEditClick = () => {
    dispatch(setHighlightShutdownTime(true));
    dispatch(updateActiveTabIndex(SETTING_TAB_INDEX.TIMING));
  };

  return (
    <div className='flex items-center ~gap-2/3 min-w-max'>
      <div className='flex items-center ~gap-1.5/2 rounded-md border border-secondary-400 dark:border-secondary-dark-500 bg-white dark:bg-secondary-dark-200 ~px-2/3 ~py-1/1.5'>
        <Zzz
          className='~w-3.5/5 ~h-3.5/5 bg-primary-600 rounded-full'
          fill={COLOR.WHITE}
          fillDarkMode={COLOR.WHITE}
        />
        <span className='~text-[0.6rem]/sm font-medium text-gray-900 dark:text-secondary-dark-900'>
          {t('settings_page.routine_start', { time: displayTime })}
        </span>
      </div>
      <BaseButton
        onClick={handleEditClick}
        icon={<EditTimeIcon className='~w-3.5/5 h-auto' />}
        variant='secondary'
        size='xs'
        aria-label={t('settings_page.routine_start', { time: displayTime })}
      />
    </div>
  );
};

export default EveningRoutineStartTimeRevamp;
